export const ACCESSORY_GROUP_APPLIED_CHANNEL = Object.freeze({
  BOTH: 1, // Tất cả kênh
  OFFLINE: 2, // Kênh offline
});
